import { z } from 'zod';
import { ZBoundingBox2D, ZCoordinate, ZDateish, ZDeviceCategoryEnum, ZDirection, ZPolygon2D, ZProjectNo } from './foundationSchema';
import { ZDevice } from './deviceSchema';
export const ZFurnitureFromItem = z.object({
    name: z.string(),
    bbox: ZBoundingBox2D
});
export const ZMlCeilingGridIntersection = z.object({
    x: z.number(),
    y: z.number(),
    direction: z.object({ x: z.number(), y: z.number() }).optional(),
});
export const ZMlInputToPredictCeilingDevices = z.object({
    projectNo: z.number(),
    roomNumber: z.string(),
    polygon: ZPolygon2D,
    furnitures: z.array(ZFurnitureFromItem),
    ceilingGridIntersection: ZMlCeilingGridIntersection.optional(),
});
export const ZMLPredictDevice = z.object({
    deviceCategory: ZDeviceCategoryEnum,
    direction: ZDirection,
    coordinate: ZCoordinate,
});
// Detta sparas på rummet efter ML-prediction har körts och resultatet importeras
export const ZMLPredictionMetadata = z.object({
    importedAt: ZDateish,
    generatedAt: ZDateish.optional().nullable(),
    source: z.string().min(1, "source saknas"),
    blobName: z
        .string()
        .regex(/^project-\d+_room-.+\.json$/, "blobName har fel format"),
});
// Svar från ML-modellen. 
export const ZMlResponseFromMLModel = ZMLPredictDevice.array();
// Det som sparas ner på blob storage efter att ha skickat in data till ML-modellen
export const ZMlPredictionResultBlobPayload = z.object({
    projectNo: z.number(),
    roomNumber: z.string(),
    predictions: z.array(ZMLPredictDevice),
    generatedAt: z.string().nullable().optional(), // ISO
    source: z.literal("ml-simulator").or(z.string()), // hvis andre kilder også kan skrive
    processedInputBlob: z.string().nullable().optional(), // blobName som input kom fra, hvis relevant
});
export const ZTDRoom = z.object({
    _id: z.any(),
    projectNo: ZProjectNo,
    roomNumber: z.string(),
    roomLongName: z.string(),
    area: z.number(),
    polygon: ZPolygon2D,
    devices: z
        .array(ZDevice.extend({
        direction: ZDirection.optional(),
    }))
        .min(1),
});
